import { wrapSyncFunc } from '../../util';
export var array = wrapSyncFunc(function (rule, value) {
  return Array.isArray(value);
});